import { EntityState } from '@ngrx/entity';
import * as Adapters from './announcement.adapters';
import { Recipient } from '../../../interfaces';
import { Announcements } from '@app/core/async-services/http/versioned/interfaces';
import { API, Chat } from '@app/core/models';

export interface State {
  departments: EntityState<Announcements.Department>;
  hotels: EntityState<Announcements.Hotel>;
  hotelManagers: EntityState<Announcements.Manager>;
  corporateManagers: EntityState<Announcements.Manager>;
  recipients: Recipient[];
  api: {
    getHotels: API.LoadingState;
    getManagers: API.LoadingState;
    getAnnouncement: API.LoadingState;
  };
  message: Chat.Message | null;
  announcementDraft: string;
  channel: string;
}

export const initialState: State = {
  departments: Adapters.departments.getInitialState(),
  hotels: Adapters.hotels.getInitialState(),
  hotelManagers: Adapters.managers.getInitialState(),
  corporateManagers: Adapters.managers.getInitialState(),
  recipients: [],
  api: {
    getHotels: API.LoadingState.INIT,
    getManagers: API.LoadingState.INIT,
    getAnnouncement: API.LoadingState.INIT,
  },
  message: null,
  announcementDraft: '',
  channel: '',
};
